import { Component } from 'react';
import { isMobile, isBrowser } from '../../../../lib/utils';

class OnboardingModalContainer extends Component {
  componentDidMount() {
    const {
      pageStateModifiers,
      requestData,
    } = this.props;

    const thisIsMobile = isMobile();
    const isAmsRedirect = requestData?.isAmsRedirect || false;

    if (isBrowser() && isAmsRedirect) {
      pageStateModifiers.makeAndOpenOnboardingModal(thisIsMobile);
    }
  }

  render() {
    return null;
  }
}

export default OnboardingModalContainer;
